import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Link } from "react-router-dom";
import { database } from "../firebase";
import ConnectionAction from "../redux/connections/actions";
import Loader from "./Loader";
import moment from "moment";
import "./userpost.css";
import {css} from "@emotion/react";
import {DotLoader} from "react-spinners";
function ConnectRequest() {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();


  const { currentUser } = useSelector((state) => ({
    currentUser: state.profile.currentUser,
  }));
  function notifications(){
  requests.map((request)=>{
    return database
    .ref("Notifications/")
    .child(request.uid)
    .push({
      sender: currentUser.uid,
      status: "Accepted",
      requestid:request.uid,
      type:'FriendRequest',
      timestamp: moment().toDate().getTime(),
      isDeleted:'false',
      isread:"false"
    });


  })
     
    
  }
  async function acceptConnection(uid, userId) {
    setLoading(true);
    notifications();
    const updates = {};
    const updates2={};
    updates[`/connectuser/${currentUser.uid}/${uid}/status`] = "Accepted";
    updates2[`/connectuser/${uid}/${currentUser.uid}/status`] = "Accepted";
    await database
    .ref()
    .update(updates)
    await database
    .ref()
    .update(updates2).then(() => {
      return database
      .ref(`/connectuser/${currentUser.uid}`)
      .orderByChild("status")
      .equalTo("Pending")
      .once("value")
      .then(async (snapshot) => {
        const array = [];
        snapshot.forEach((childSnapshot) => {
              array.push(childSnapshot.key);
            });
            var results = await Promise.all(
              array.map(async (item) => {
                const data = await getUserData(item);
                return data;
              })
              );
              setRequests([...results]);
              setLoading(false);
            });
          });
          
          return true;
        }

async function declineConnection(uid, userId) {
setLoading(true);
    await database
      .ref(`/connectuser/${currentUser.uid}/${uid}`)
      .remove()
      .then(() => {
        database.ref(`/requests/${uid}`).child(currentUser.uid).remove()
        database.ref(`/requests/${currentUser.uid}`).child(uid).remove()
        return database
        .ref(`/connectuser/${uid}`)
        .orderByChild("status")
        .equalTo("Pending")
        .once("value")
        .then(async (snapshot) => {
          const array = [];
          snapshot.forEach((childSnapshot) => {
            array.push(childSnapshot.key);
          });
          var results = await Promise.all(
            array.map(async (item) => {
              const data = await getUserData(item);
              return data;
            })
            );
            setRequests([...results]);
            setLoading(false);
          });
        });
        
        return true;
        // database.ref(`/connectuser/SsxSEzQiq3ajtFgfDiUMarwVdC63/${uid}`).update({ status: "Accepted" });
      }
      
      
  
      
      // const { connections } = useSelector((state) => ({
        //   connections: state.connection.connections,
        
        //   Loading: state.connection.Loading,
        // }));
        
        function getUserData(uid) {
          return new Promise((resolve, reject) => {
      return database.ref("users/" + uid).once("value", (snap) => {
        resolve(snap.val());
      });
    });
  }
  
  function getConnections(uid) {
    setLoading(true);
    return database
    .ref(`/connectuser/${uid}`)
    .orderByChild("status")
    .equalTo("Pending")
    .once("value")
    .then(async (snapshot) => {
      const array = [];
      snapshot.forEach((childSnapshot) => {
        array.push(childSnapshot.key);
      });
      var results = await Promise.all(
        array.map(async (item) => {
          const data = await getUserData(item);
          return data;
          })
          );
          setRequests([...results]);
          setLoading(false);
          return array;
        });
      }
      useEffect(() => {
      
    getConnections(currentUser.uid);
  }, []);
  
  

  const override = css`
  display: block;
  margin: 0 auto;
  border-color: purple;
  color: purple;
  opacity: 0.5;
  `;

  let [color] = useState();
  return loading == true ? (
      <DotLoader color={color} css={override} size={100} color={"#7444C0"}
      />
    ) : (
    <div className="card border-0 rounded-xl shadow-xs" style={{height:'300px'}} >
    
      <div className="card-body p-4">
        <div className="d-flex justify-content-between fs-12">
          <span className="fw-bold">Connect Request</span>
          <Link
            to="/requests"
            className="fw-bold text-decoration-none text-primary"
            title="See all"
          >
            See all
          </Link>
        </div>
        {requests &&
          requests.map((arr) => {
            return (
              <div className="mt-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="mmwh-45 overflow-hidden rounded-pill me-3">
                    <img src={arr?.profileImageUrl} alt="user" />
                  </div>
                  <div className="ms-3">
                    <h5 className="fs-13 fw-bold mb-0">{arr.firstName}</h5>
                  </div>
                </div>
                <button
                  className="btn btn-primary fw-medium rounded-pill px-3"
                  onClick={() => acceptConnection(arr.uid)}
                >
                  Accept
                </button>
                <button
                  className="btn btn-secondary fw-medium rounded-pill px-3"
                  onClick={() => declineConnection(arr.uid)}
                >
                  Ignore
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}
export default ConnectRequest;
